import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

/**
 * Visible breadcrumb trail — presentation only.
 *
 * NOTE: This component NO LONGER emits BreadcrumbList JSON-LD. Every page
 * that uses this component already emits its own `breadcrumbSchema` via
 * <SEO schemas={[...]}> (BoardCoursePage, OnlineCity, InternationalCity,
 * CityLanding, MakeoverLanding, BoardSubjectCity, HomeTuitionLocality,
 * BlogDetail, etc.). Emitting the schema here caused every one of those
 * pages to render TWO identical BreadcrumbList entities in <head> — a
 * validation warning Google's Structured Data testing tool flags.
 * De-duplicated in the Batch 2Q pre-deploy audit (Feb-2026).
 *
 * Props:
 *   items: [{ name: "Cities", to: "/" }, { name: "Jabalpur" }]  // last item = current page (no `to`)
 */
export default function Breadcrumbs({ items = [] }) {
    if (!items.length) return null;
    const all = [{ name: "Home", to: "/" }, ...items];

    return (
        <nav
            data-testid="breadcrumbs"
            aria-label="Breadcrumb"
            className="bg-slate-50 border-b border-slate-100"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-8 py-3 flex items-center gap-1.5 text-xs text-slate-500 overflow-x-auto">
                {all.map((item, i) => (
                    <div key={`${item.name}-${i}`} className="flex items-center gap-1.5 whitespace-nowrap">
                        {i > 0 && <ChevronRight className="w-3 h-3 text-slate-300" />}
                        {item.to ? (
                            <Link to={item.to} className="hover:text-[#1E3A8A] transition-colors inline-flex items-center gap-1">
                                {i === 0 && <Home className="w-3 h-3" />}
                                {item.name}
                            </Link>
                        ) : (
                            <span className="text-slate-800 font-semibold">{item.name}</span>
                        )}
                    </div>
                ))}
            </div>
        </nav>
    );
}
